const userDefaults = {};
const defaults = {
    profilePicture: "user.png",
};
const variables = {
    banks: [],
    categories: [],
    labels: [],
};
const tooltips = null;
const summaries = {};

const state = {
    activeUser: userDefaults,
    defaults: defaults,
    summaries: summaries,
    variables: variables,
    tooltips: tooltips,
};

export default state;
